
import { Component, Vue, Prop } from 'vue-property-decorator'
/**
 * @prop value      表格数据
 * @emit examine    审核
 */
@Component({
    name: 'release-list-table'
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]
}
